import React from 'react'
import { Link } from 'react-router-dom'
import MetaTags from '../components/MetaTags'
import GallerySection from '../components/GallerySection'

export default function CommercialCleaning() {
  const pageImage = 'https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/8bec77d8-9a30-4008-bc94-797ed827a99a/erhverv-office-cleaning.jpg'

  return (
    <div>
      <MetaTags
        title="Erhvervsrengøring - Elses skrub og skur"
        description="Professionel erhvervsrengøring og kontorrengøring i Skjern. Rene lokaler og et indbydende arbejdsmiljø til din virksomhed."
      />

      {/* Hero Header */}
      <section className="bg-[#FAF9F5] py-12 lg:py-16 border-b border-[#E2E7E2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
            
            <div className="lg:col-span-7 space-y-5">
              <span className="text-xs font-bold uppercase tracking-wider text-[#3A684D] bg-[#EEF4F0] px-3.5 py-1.5 rounded-full inline-block border border-[#D2E0D6]">
                Erhvervsrengøring
              </span>
              
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-serif-display font-bold text-[#285F41] tracking-tight leading-tight">
                Professionel erhvervsrengøring til virksomheder i Skjern
              </h1>

              <p className="text-base sm:text-lg text-[#4A5D50] leading-relaxed">
                Et rent arbejdsmiljø skaber trivsel og giver et godt indtryk hos dine kunder og samarbejdspartnere. Elses skrub og skur leverer stabil og grundig erhvervsrengøring til tilpassede tider.
              </p>

              <div className="flex flex-wrap items-center gap-4 pt-2">
                <a
                  href="tel:52506794"
                  className="contact-no-break inline-flex items-center gap-2.5 px-6 py-3.5 rounded-xl bg-[#285F41] text-white font-semibold text-sm shadow-md hover:bg-[#357753] transition-all"
                >
                  <i className="fa-solid fa-phone text-emerald-300" aria-hidden="true"></i>
                  <span>Ring på 52 50 67 94</span>
                </a>

                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 px-6 py-3.5 rounded-xl bg-white text-[#285F41] font-semibold text-sm border border-[#D2E0D6] hover:bg-[#EEF3EF] transition-all"
                >
                  <span>Kontakt mig om erhverv</span>
                  <i className="fa-regular fa-arrow-right text-xs" aria-hidden="true"></i>
                </Link>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="rounded-2xl overflow-hidden border border-[#D5E1D8] shadow-lg">
                <img
                  src={pageImage}
                  alt="Moderne og rent erhvervsmiljø i Skjern"
                  className="w-full h-[340px] object-cover"
                />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Main Content Details */}
      <section className="py-16 bg-white border-b border-[#E2E7E2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          
          <div className="max-w-3xl mx-auto text-center space-y-3">
            <h2 className="text-2xl sm:text-3xl font-serif-display font-bold text-[#285F41]">
              Lokal og fleksibel rengøringspartner til din virksomhed
            </h2>
            <p className="text-sm text-[#4A5D50] leading-relaxed">
              Jeg forstår, at enhver arbejdsplads har sine egne rutiner. Derfor skræddersyer jeg erhvervsrengøringen, så den forstyrrer hverdagen mindst muligt.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 [&>:last-child]:md:col-span-2 [&>:last-child]:lg:col-span-1">
            
            <div className="bg-[#FAF9F5] p-6 rounded-2xl border border-[#D9E3DC] space-y-3">
              <div className="w-10 h-10 rounded-xl bg-[#EEF4F0] text-[#285F41] flex items-center justify-center text-lg">
                <i className="fa-regular fa-building-user" aria-hidden="true"></i>
              </div>
              <h3 className="text-lg font-bold text-[#285F41]">
                Kontorer &amp; Arbejdsstationer
              </h3>
              <p className="text-xs text-[#4A5D50] leading-relaxed">
                Støvsugning, gulvvask og aftørring af skriveborde, mødelokaler og fællesarealer.
              </p>
            </div>

            <div className="bg-[#FAF9F5] p-6 rounded-2xl border border-[#D9E3DC] space-y-3">
              <div className="w-10 h-10 rounded-xl bg-[#EEF4F0] text-[#285F41] flex items-center justify-center text-lg">
                <i className="fa-regular fa-mug-hot" aria-hidden="true"></i>
              </div>
              <h3 className="text-lg font-bold text-[#285F41]">
                Personalekøkken &amp; Toiletter
              </h3>
              <p className="text-xs text-[#4A5D50] leading-relaxed">
                Hygiejnisk og grundig rengøring af kantine, pauserum samt medarbejder- og kundetoiletter.
              </p>
            </div>

            <div className="bg-[#FAF9F5] p-6 rounded-2xl border border-[#D9E3DC] space-y-3">
              <div className="w-10 h-10 rounded-xl bg-[#EEF4F0] text-[#285F41] flex items-center justify-center text-lg">
                <i className="fa-regular fa-clock" aria-hidden="true"></i>
              </div>
              <h3 className="text-lg font-bold text-[#285F41]">
                Fleksible Udførelsestider
              </h3>
              <p className="text-xs text-[#4A5D50] leading-relaxed">
                Aftaler tilpasses din virksomheds arbejdstider, så rengøringen passer naturligt ind.
              </p>
            </div>

          </div>

          {/* Business Banner */}
          <div className="bg-[#FAF9F5] p-8 rounded-2xl border border-[#D9E3DC] grid grid-cols-1 md:grid-cols-12 gap-6 items-center">
            <div className="md:col-span-8 space-y-2">
              <h3 className="text-xl font-bold text-[#285F41]">
                Ønsker du en uforpligtende besigtigelse i Skjern?
              </h3>
              <p className="text-xs text-[#4A5D50] leading-relaxed">
                Kontakt mig direkte på telefon eller mail. Jeg kommer gerne ud og kigger på lokalerne, så I kan få en aftale tilpasset jeres lokaler.
              </p>
            </div>
            <div className="md:col-span-4 flex flex-col sm:flex-row md:flex-col gap-3 justify-end">
              <a
                href="tel:52506794"
                className="contact-no-break text-center px-4 py-3 rounded-xl bg-[#285F41] text-white font-semibold text-xs hover:bg-[#357753] transition-colors"
              >
                Ring: 52 50 67 94
              </a>
              <Link
                to="/kontakt"
                className="text-center px-4 py-3 rounded-xl bg-white text-[#285F41] font-semibold text-xs border border-[#D2E0D6] hover:bg-[#EEF3EF] transition-colors"
              >
                Kontaktformular
              </Link>
            </div>
          </div>

        </div>
      </section>

      {/* DYNAMIC CMS GALLERY */}
      <GallerySection
        reference="erhvervsrengoering"
        title="Billeder fra erhvervsrengøring"
        description="Se eksempler på mine rengøringsopgaver i erhvervslokaler."
      />

    </div>
  )
}
